export default "__VITE_ASSET__931cdd99__"